import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
        },
        sizeLarge: {
          height: 44,
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: "none",
          backgroundColor: theme.palette.common.black,
          color: theme.palette.getContrastText(theme.palette.common.black),
        },
        containedSecondary: {
          boxShadow: "none",
        },
        containedSuccess: {
          boxShadow: "none",
        },
        containedWarning: {
          boxShadow: "none",
        },
        containedError: {
          boxShadow: "none",
        },
        // outlined
        outlined: {
          color: theme.palette.grey[700],
          backgroundColor: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[300]}`,
          "&:hover": {
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.grey[500_12],
          },
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
